import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { projectFeedBackend } from './project-feed.backend';
import { projectFeedReducer } from './project-feed.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('projectFeed', projectFeedReducer),
    BackendModule.forFeature('projectFeed', projectFeedBackend),
  ],
})
export class DatastoreProjectFeedModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed/project-feed.module.ts